<template>
  <div class="result">
    <div class="result_nav">
      <navbar
        :titletext="pageTitle"
        :lefticon="lefticon"
        :lefticonheight="1.8"
        :lefticonwidth="1.8"
        :fontweight="700"
        :fontsize="'1.8rem'"
        @goback="goBack(false)"
      />
    </div>
    <div class="box">
      <van-row class="content">
        <van-col span="24" class="icon">
          <img src="../../assets/purchaseSupplier/order/success.png" />
        </van-col>
        <van-col span="24" class="tips">{{ tips }}</van-col>
      </van-row>
    </div>

    <van-popup class="tipPopup" v-model="tipsShow">
      <p class="title">温馨提示</p>
      <p class="con">为保证您的权益，您需要签署《汽车租赁合同》</p>
      <btn
        :btntext="'去签署'"
        :btnwidth="'11.4rem'"
        :height="'3.6rem'"
        :bgcolor="'linear-gradient(to right, #49A6FF, #236DFE)'"
        :borderradius="'0.6rem'"
        :btncolor="'#fff'"
        :fontsize="'1.4rem'"
        :btnmargin="'0 0 0 6.9rem'"
        @btnClick="goSign"
      />
    </van-popup>
  </div>
</template>
<script>
import navbar from "../purchaseSupplier/components/nav-bar.vue";
import btn from "../purchaseSupplier/components/button.vue";
export default {
  components: {
    navbar,
    btn,
  },
  data() {
    return {
      lefticon: require("@/assets/carRent/reback@2x.png"),
      pageTitle: "支付成功",
      tips: "支付成功",
      tipsShow: true,
    };
  },
  created() {},
  methods: {
    goBack() {
      this.$router.replace({
        path: "/carRent/payedDetail",
        query: {
          order_num: this.$route.query.order_num,
        },
      });
    },
    goSign() {
      sessionStorage.setItem("signedBack", 3);
      this.$router.push({
        path: "/carRent/pdf",
        query: {
          order_id: this.$route.query.order_id,
          signed: 0,
          from: "h5",
        },
      });
    },
  },
};
</script>
<style lang="less" scoped>
.result {
  height: 100%;
  box-sizing: border-box;
  background: #f5f6f7;

  .result_nav {
    position: fixed;
    top: 0;
    width: 100%;
    padding-top: 4.4rem;
    z-index: 3;
    background: #fff;
  }

  .box {
    padding: 10.3rem 1.6rem 0;
    box-sizing: border-box;
    height: 100%;
    overflow-y: scroll;
    -webkit-overflow-scrolling: touch;

    .content {
      height: 25.7rem;
      text-align: center;
      background: #fff;
      margin-bottom: 1.6rem;
      padding: 6.7rem 1.6rem;
      border-radius: 0.8rem;
      box-sizing: border-box;

      .icon {
        text-align: center;

        img {
          width: 8.1rem;
          margin-bottom: 1.2rem;
        }
      }

      .tips {
        color: #333;
        font-size: 2rem;
        line-height: 2.8rem;
        font-weight: 700;
      }
    }
  }

  .tipPopup {
    width: 29.6rem;
    border-radius: 0.8rem;
    padding: 3rem 2.2rem 2.2rem;
    box-sizing: border-box;
    color: #333;

    .title {
      font-size: 1.6rem;
      font-weight: 700;
      text-align: center;
      margin-bottom: 2rem;
    }

    .con {
      font-size: 1.4rem;
      line-height: 2.5rem;
      margin-bottom: 4.2rem;
    }
  }
}
</style>